import React from 'react';
import { slideWrapper } from '../components/slide';
import styled from 'styled-components';
import { PuzzleItems } from '../components/puzzle-items';
import { RoundLetters, RoundType } from '@disco/data';

import { Content } from '../components/content';
import { SlideImage } from '../components/slide-image';

export const TeslaPuzzle1Counting = slideWrapper(
  ({ step, getImg, countingResults, countingResultsLoading }) => {
    const { answers } = step;

    return (
      <>
        <Content left={4} top={5} xNotCenter yNotCenter>
          <SlideImage width="150px" rotate={'-10deg'} src={getImg('pytajnik')} show={true} />
        </Content>
        <Content left={20} top={14} yNotCenter>
          <SlideImage width="350px" src={getImg('lornetka')} show={true} />
        </Content>
        <PuzzleItems
          {...{ countingResults, countingResultsLoading, getImg, answers, letters: RoundLetters[5] }}
          smallItem
        />
      </>
    );
  },
  { countAnswersTour: RoundType.Tesla }
);
